export default __webpack_public_path__ + "static/media/bi.1162f2ac.svg";